export const DASHBOARD_HEADER_HEIGHT = 50;
export const DASHBOARD_HEADER_ZINDEX = 99;
// The edit mode band that stands in for the header with dashboard controls on
export const DASHBOARD_EDIT_BAND_HEIGHT = 44;
export const DASHBOARD_TAB_HEIGHT = 50;
export const DASHBOARD_TABS_ZINDEX = 98;
// A tile card's corner radius in px, square-ish while it is edited
export const DASHBOARD_TILE_RADIUS = { edit: 4, view: 12 };
// The dashboard's scroll-to-top button: its size and its distance from the
// bottom, higher while the AI launcher is mounted
export const SCROLL_TO_TOP_SIZE = 40;
export const SCROLL_TO_TOP_BOTTOM = 24;
export const SCROLL_TO_TOP_BOTTOM_WITH_LAUNCHER = 52;
